import React from "react";
import styled from "styled-components";
import logoImg from "../Img/logo_Sticker.svg";
import deliveryImg from "../Img/delivery.svg";

const A4Wapper = styled.div`
width: 210mm;
height: 297mm;
display: flex;
background-color: #fff;
margin: 0 auto;
`;

const Wrapper = styled.div`
  width: 200mm;
  height: 93mm;
  border-radius: 2mm;
  padding: 10mm 3.5mm;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const LabelWrapper = styled.div`
  border: 0.5px solid black;
  width: 193mm;
  height: 40mm;
  margin: 0mm auto;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 70mm 35mm auto;
  grid-template-rows: repeat(2, 1fr);
  font-family: sans-serif;
  background-color: #fff;

  & > div {
    border: 0.5px solid rgba(0, 0, 0, 0.3);
  }
  div {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .bold {
    font-size: 20px;
    font-weight: 800;
  }
  .value {
    font-size: 18px;
  }
`;

const Logo = styled.div`
  img {
    width: 38mm;
  }
`;
const Delivery = styled.div`
  margin-top: 40px;
  img {
    width: 100mm;
  }
`;

function RenderLabel({ model, number, total }) {
  return (
    <Wrapper>
      <LabelWrapper>
        <div style={{ gridRow: "1 / span 2", gridColumn: "1" }}>
          <Logo>
            <img src={logoImg} />
          </Logo>
        </div>
        <div style={{ gridRow: "1", gridColumn: "2" }} className="bold">
          Model
        </div>
        <div style={{ gridRow: "1", gridColumn: "3" }} className="value">
          {model}
        </div>
        <div style={{ gridRow: "2", gridColumn: "2" }} className="bold">
          Qty
        </div>
        <div style={{ gridRow: "2", gridColumn: "3" }} className="value">
          {number}/{total}
        </div>
      </LabelWrapper>
      <Delivery>
        <img src={deliveryImg} />
      </Delivery>
    </Wrapper>
  );
}

export default RenderLabel;
